<template>
  <div
    v-if="showLogo"
    id="InicioLogo"
    class="overlay-invitacion"
    @click="handleClickAnywhere"
  >
    <transition name="fade-out">
      <div v-if="!transitioning" class="escena-sobre">
        
        <img src="@/assets/flores-izq.png" class="flor flor-izq-fondo" alt="">
        <img src="@/assets/flores-der.png" class="flor flor-der-fondo" alt="">

        <div class="sobre-wrapper">
          <img src="@/assets/64556be7c96cea124860a6b78e464182.png" class="sobre-img" alt="Sobre de invitación">
          
          <div class="info-sobre">
            <!-- Corona arriba de Kenia -->
            <img src="@/assets/corona22.png" class="corona-img" alt="Corona" />

            <p class="nombres-logo">
              Kenia 
            </p>

            <!-- Subtítulo elegante abajo de Kenia -->
            <p class="mis-xv-texto">
              Mis XV Años
            </p>

            <p class="fecha-logo"></p>
          </div>

          <img src="@/assets/lacre22.png" class="sello-img" alt="Sello de lacre">
        </div>

        <p class="click-to-open" :class="{ 'show-click': showTooltip }">
          PRESIONA PARA ABRIR
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
import { gsap } from "gsap";

export default {
  name: 'InicioLogo',
  data() {
    return {
      showTooltip: false,
      showLogo: true,
      transitioning: false,
    };
  },
  mounted() {
    this.initAnimations();
    
    // El texto aparece más rápido ahora (1.5 segundos)
    setTimeout(() => {
      this.showTooltip = true;
    }, 1500);
  },
  methods: {
    initAnimations() {
      const tl = gsap.timeline();

      // Animación de entrada para el sobre y flores
      tl.from(".sobre-wrapper", {
        y: 50,
        opacity: 0,
        duration: 1.2,
        ease: "power2.out"
      })
      .from(".flor-izq-fondo", {
        x: -30,
        opacity: 0,
        duration: 1,
        ease: "power2.out"
      }, "-=0.8")
      .from(".flor-der-fondo", {
        x: 30,
        opacity: 0,
        duration: 1,
        ease: "power2.out"
      }, "-=0.8")
      .from(".info-sobre", {
        opacity: 0,
        y: 10,
        duration: 0.8
      }, "-=0.5");
    },
    handleClickAnywhere() {
      this.transitioning = true;
      setTimeout(() => {
        this.showLogo = false;
      }, 1000);
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&family=Great+Vibes&family=Cinzel:wght@400;600&display=swap');

.overlay-invitacion {
  position: fixed;
  left: 0;
  width: 100vw;
  padding-top: 30px;
  height: 100vh;
  background-color: #f1f0ee;
  background-image: url('@/assets/dd8428dbdfc528757dc41c0e32ba417d.png');
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  cursor: pointer;
  overflow: hidden;
}

.escena-sobre {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 500px;
}

.sobre-wrapper {
  position: relative;
  width: 85%;
  max-width: 400px;
  z-index: 10;
  filter: drop-shadow(0 15px 30px rgba(0,0,0,0.1));
}

.sobre-img {
  width: 100%;
  height: auto;
  display: block;
}

.info-sobre {
  
  position: absolute;
  top: -195px !important; /* Posicionado delicadamente sobre el sobre */
  width: 100%;
  text-align: center;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.corona-img {
  width: 135px;
  height: auto;
  margin-bottom: 2px;

  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.15));
}

.nombres-logo {
  font-family: 'ludovica', 'Great Vibes', cursive !important;
  font-size: 4.8rem !important;
  font-style: italic;
  color: #677380 !important; /* 🔥 Color azul pizarra de la imagen */
  margin: 0;
  line-height: 1;
  margin-left: -20px;;
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.8);
}

.mis-xv-texto {
  font-family: 'Cinzel', 'Playfair Display', serif;
  font-size: 1.3rem;
  letter-spacing: 4px;
  color: #57636e; /* 🔥 Mismo tono para coherencia del cuento */
  text-transform: uppercase;
  margin: 6px 0 2px 0;
  font-weight: 600;
}

.fecha-logo {
  font-family: 'Playfair Display', serif;
  font-size: 0.8rem;
  letter-spacing: 3px;
  color: #666;
  margin-top: 4px;
}

.sello-img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -10%);
  width: 0px !important;
  z-index: 15;
}

.flor {
  position: absolute;
  width: 180px;
  height: auto;
  pointer-events: none;
}

/* Ajuste de posición exacto */
.flor-izq-fondo { bottom: 25%; left: -5%; z-index: 0; opacity: 0; }
.flor-der-fondo { top: -5%; right: -5%; z-index: 0; opacity: 0;}

.click-to-open {
  margin-top: 10px;
  font-family: 'Playfair Display', serif;
  letter-spacing: 3px;
  font-size: 1rem;
  color: #4f4d4d;
  opacity: 0;
  transition: opacity 0.8s ease;
  text-transform: uppercase;
}

.show-click { opacity: 1; }

.fade-out-leave-active {
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.fade-out-leave-to {
  opacity: 0;
  transform: scale(1.05);
}


</style>